// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "vue-assets/css/" + chunkId + "." + {"151":"36d8d072","152":"913fd193","336":"beee6a2d","678":"dfcd57e0","882":"0844dd5a"}[chunkId] + ".css";
};